"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18.7 25",
    width: "18.7",
    height: "25"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#004864",
    d: "M18.2,25H0.5C0.2,25,0,24.8,0,24.5v-24C0,0.2,0.2,0,0.5,0H12c0.1,0,0.3,0.1,0.4,0.1l6.3,6.3c0.1,0.1,0.1,0.2,0.1,0.4v17.7 C18.7,24.8,18.5,25,18.2,25z M1,24h16.7V7l-6-6H1V24z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#004864",
    d: "M18.2,7.3H12c-0.3,0-0.5-0.2-0.5-0.5V0.5C11.5,0.2,11.7,0,12,0s0.5,0.2,0.5,0.5v5.8h5.8c0.3,0,0.5,0.2,0.5,0.5 S18.5,7.3,18.2,7.3z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#004864",
    d: "M3.6,17.7c-0.1,0-0.3,0-0.4-0.1c-0.2-0.2-0.2-0.5,0-0.7l4.2-4.2c0.2-0.2,0.4-0.2,0.6-0.1l2.8,1.9l3.6-3.9 c0.2-0.2,0.5-0.2,0.7,0c0.2,0.2,0.2,0.5,0,0.7l-3.9,4.2c-0.2,0.2-0.4,0.2-0.6,0.1l-2.8-1.9L4,17.5C3.9,17.6,3.8,17.7,3.6,17.7z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#004864",
    d: "M15.1,20.8H3.6c-0.3,0-0.5-0.2-0.5-0.5v-12c0-0.3,0.2-0.5,0.5-0.5S4.1,8,4.1,8.3v11.5h11c0.3,0,0.5,0.2,0.5,0.5 S15.4,20.8,15.1,20.8z"
  }));
};

exports["default"] = _default;